module.exports = __webpack_public_path__ + "media/images/icons/chart-6bf262fd8adc6fe8a5c5d585144c9c37.svg";